import {createSelector} from '@reduxjs/toolkit';

export const bypassExpenseStateSelector = {
  getActiveStatus: () => {
    return createSelector(
      [(state: any) => state.bypassExpense.activeStatus],
      activeStatus => activeStatus,
    );
  },
  getToggleStatus: () => {
    return createSelector(
      [(state: any) => state.bypassExpense.toggleStatus],
      toggleStatus => toggleStatus,
    );
  },
  getIsLoading: () => {
    return createSelector(
      [(state: any) => state.bypassExpense.isLoading],
      isLoading => isLoading,
    );
  },
  getBypassExpenseGridData: () => {
    return createSelector(
      [(state: any) => state.bypassExpense.bypassExpenseGridData],
      bypassExpenseGridData => bypassExpenseGridData,
    );
  },
  getBypassExpenseGridLoading: () => {
    return createSelector(
      [(state: any) => state.bypassExpense.bypassExpenseGridLoading],
      bypassExpenseGridLoading => bypassExpenseGridLoading,
    );
  },
  getBypassExpenseSelectedExpenseIds: () => {
    return createSelector(
      [(state: any) => state.bypassExpense.bypassExpenseSelectedExpenseIds],
      bypassExpenseSelectedExpenseIds => bypassExpenseSelectedExpenseIds,
    );
  },
};
